export default "__VITE_ASSET__Dgn3azyZ__"